var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"flat":"","outlined":""}},[_c('v-card-title'),_c('v-card-text',_vm._l((_vm.examquestions),function(question){return _c('div',{key:question,staticStyle:{"margin-bottom":"10px"}},[_c('Question',{key:question.key,attrs:{"path":question.path,"source":"Exam"}})],1)}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }